// @flow

import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'billing',
  `
    CHANGE_PAGE

    SELECT_BILLING_INTERVAL

    CONFIRM_PLAN_CHANGE
    CHANGE_PLAN_ERROR

    EDIT_CARD
    CANCEL_EDIT_CARD

    ON_LEAVE

    GO_TO_DASHBOARD
    GO_TO_MEMBER_HOME
    GO_TO_PLAN_INTERVAL_CHANGE
    GO_TO_UPGRADE_TO_TEAMS

    CONFIRM_DOWNGRADE_PLAN

    TOGGLE_DOWNGRADE_UNDERSTOOD

    SHOW_DOWNGRADE_SURVEY
    SHOW_DOWNGRADE_OFFER

    SET_IN_FLIGHT

    CANCEL_DOWNGRADE

    GET_CURRENCY_RATES
    GET_CURRENCY_RATES_DONE
    GET_CURRENCY_RATES_FAIL
    SELECT_CURRENCY
  `
);
